<script setup lang="ts">
const { loggedIn } = useUserSession();
</script>

<template>
  <div class="flex flex-col grow bg-white relative">
    <WebHeader />
    <div class="flex flex-col grow [--ui-content-height:calc(100svh-var(--ui-header-height))] min-h-(--ui-content-height)">
      <UMain role="main" class="flex flex-col grow min-h-auto">
        <WebSessionExpiredBanner />
        <slot />
      </UMain>
      <WebFooterGuests />
      <WebFooter />
    </div>
    <WebActivityLeaveModal />
    <LazyWebLicenseModal v-if="loggedIn" />
    <LazyWebSiteCreateModal v-if="loggedIn" />
  </div>
</template>
